const STATS = [
  { value: '2.4M+', label: 'Packages Delivered', icon: 'ri-box-3-line' },
  { value: '180+', label: 'Countries & Territories', icon: 'ri-global-line' },
  { value: '99.7%', label: 'On-Time Delivery Rate', icon: 'ri-time-line' },
  { value: '50k+', label: 'Business Clients', icon: 'ri-building-2-line' },
  { value: '$12B+', label: 'Cargo Value Protected', icon: 'ri-shield-check-line' },
  { value: '4.9★', label: 'Customer Rating', icon: 'ri-star-line' },
];

export default function StatsSection() {
  return (
    <section className="py-16 border-y border-gray-100" style={{ background: '#f9fafb' }}>
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-8">
          {STATS.map(({ value, label, icon }) => (
            <div key={label} className="text-center">
              <div
                className="w-10 h-10 rounded-xl flex items-center justify-center mx-auto mb-3"
                style={{ background: 'var(--primary-light)' }}
              >
                <i className={`${icon} text-lg`} style={{ color: 'var(--primary)' }} />
              </div>
              <div className="font-heading font-bold text-2xl text-gray-900 mb-1">{value}</div>
              <div className="text-gray-500 text-xs leading-snug">{label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
